import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './font-awesome'; // Font Awesome 라이브러리 설정 파일 import
import '@fortawesome/fontawesome-svg-core/styles.css'; // Font Awesome CSS import
import { config } from '@fortawesome/fontawesome-svg-core';
import { BrowserRouter } from 'react-router-dom';
config.autoAddCss = false;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
